module.exports = __webpack_public_path__ + "img/Kypho V2 960x540.6dae6d73.png";